module.exports = {"title":"Notification Settings","push":"Notifications","sms":"SMS","email":"Email"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/se211.json
// module id = M/LE
// module chunks = 2